<template>
  <div>
    <div class="header">
      <div class="nav_box">
        <div class="yjh_nav w">
          <div class="logo">
            <img :src="src.logo" alt srcset />
          </div>
          <el-menu :defaultActive="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1">
              <router-link to="/index">首页 </router-link>
            </el-menu-item>
            <el-menu-item index="2">
              <router-link to="/aboutUs">关于我们 </router-link>
            </el-menu-item>
            <el-submenu index="3">
              <template slot="title">媒体新闻</template>
              <el-menu-item index="3-1">
                <router-link to="/newsConsult">新闻资讯 </router-link>
              </el-menu-item>
              <el-menu-item index="3-2">
                <router-link to="/videoMedia">视频媒体 </router-link>
              </el-menu-item>
              <el-menu-item index="3-3">
                <router-link to="/qiyeConsult">企业资讯 </router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="4">
              <router-link to="/enterprise">企业服务 </router-link>
            </el-menu-item>
            <!-- <el-submenu index="5">
            <template slot="title">用户服务</template>
            <el-menu-item index="5-1">
              <router-link to="/recruitCenter">招聘中心 </router-link>
            </el-menu-item>
          </el-submenu> -->
            <el-menu-item index="6">
              <router-link to="/contactUs">联系我们 </router-link>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="banner">
        <el-carousel>
          <el-carousel-item v-for="(item, index) in item" :key="index">
            <img :src="item.url" alt srcset />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="header_mobile">
      <yjh-menu id="menu" class="menuClose"></yjh-menu>
      <div class="header_box">
        <div class="header_nav">
          <span class="iconfont iconcaidan" @click.stop="navChange"></span>
          深圳市云久鸿劳务派遣有限公司
        </div>
        <div class="banner">
          <div class="title">深圳市云久鸿劳务派遣有限公司</div>
          <div class="sub_title">
            Welcome to Cloud long hon human resources group co., LTD
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import src from "../utils/assets";
import menu from "@/layouts/menu";
export default {
  components: {
    "yjh-menu": menu,
  },
  props: ["activeIndex"],
  data() {
    return {
      src: src,
      item: [{ url: src.banner }],
      showSelectDataSrc: true,
    };
  },
  created() {
    document.addEventListener("click", function (e) {
      if (e.target.className != "menuClose" && e.target.className != "iconfont") {
        // console.log(1);
        document.getElementById("menu").classList.remove("menuOpen");
        // console.log(document.getElementById("menu"));
      }
    });
  },
  methods: {
    navChange() {
      // console.log(1);
      document.getElementById("menu").classList.add("menuOpen");
    },
  },
};
</script>

<style lang="less">
// 移动端
@media screen and (max-width: 999px) {
  // .model_zone {
  //   display: none;
  // }

  .menuClose {
    position: absolute;
    left: -150px;
    top: 0;
    transition: left 0.2s ease-out;
  }
  .menuOpen {
    height: 100vh;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
  }
  .header {
    display: none;
  }
  .header_mobile {
    // display: flex;
    width: 100%;
    display: flex;
    transition: left 0.4s ease-out;
    // position: absolute;
    // left: 0px;
    // margin-bottom: 100px;
    .header_box {
      width: 100%;
    }
    .header_nav {
      width: 100vw;
      height: 55px;
      line-height: 55px;
      text-align: center;
      position: fixed;
      top: 0;
      font-size: 20px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px #000;
      z-index: 5;
      .iconfont {
        position: absolute;
        left: 10px;
        font-weight: 700;
      }
    }
    .banner {
      width: 100%;
      height: 150px;
      margin-top: 55px;
      background-image: url("https://yunjiuhong.oss-cn-zhangjiakou.aliyuncs.com/website/2020/12/28/R8p8rpSnhZPu1ugktJ8xkWZLrSnTGw5PfWOBzZOL.png");
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 30px;
      color: #fff;
      text-align: center;
      .title {
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
      }
    }
  }
}
// PC端
@media screen and (min-width: 1000px) {
  .header {
    display: block;
    height: 512px;

    .nav_box {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      width: 100%;
      height: 60px;
      background-color: #fff;
      z-index: 10;
      .yjh_nav {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 10;
        .el-menu.el-menu--horizontal {
          border-bottom: none;
        }
        .el-menu--horizontal > .el-menu-item.is-active {
          border-bottom: 2px solid #da261d;
          color: #303133;
        }
        .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
          border-bottom: 2px solid #da261d;
          color: #303133;
        }
        .el-menu {
          background-color: rgba(0, 0, 0, 0);
        }
        .el-menu--horizontal > .el-menu-item {
          color: #000;
        }
        .el-menu--horizontal > .el-submenu .el-submenu__title {
          color: #000;
        }
      }
    }

    .banner {
      margin-top: 60px;
      width: 100%;
      position: absolute;
      top: 0;
      .el-carousel__container {
        position: relative;
        height: 512px;
      }
      img {
        width: 100%;
        height: 512px;
      }
      ::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
    }
  }
  .header_mobile {
    display: none;
  }
}
</style>
